<template>
  <div>
    <PageAllow controller="MaterialSales" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherOrderDate
              v-model="datetimeRage"
              show-radio
              show-radio-actual
              show-radio-pay
              show-radio-expect
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-btn
              v-show="materialSales.length"
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleBarEcharts')"
            >
              {{
                $store.state.showBarEchartsPanel
                  ? $t("App.hideSparkline")
                  : $t("App.showSparkline")
              }}
              <v-icon small class="ps-1">{{
                $store.state.showBarEchartsPanel
                  ? "fa-angle-up"
                  : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="print"
              dark
              @click.stop="exportExcelDialog = true"
              v-if="$permission.permissionAllow('MaterialSales', 'export')"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel", [$t("Nav.materialSales")]) }}
            </v-btn>
            <v-btn
              small
              color="print"
              dark
              @click.stop="exportExcelJX()"
              v-if="
                $permission.permissionAllow('MaterialSales', 'jiangXiExport')
              "
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel", [$t("Nav.materialSales")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterialCategoriesWithDescendants
                  v-model="categoriesSelected"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="keyword"
                  v-model="options.material_keyword"
                  @text="materialKeyword = $event"
                  :label="$t('MaterialSales.material_keyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherAlliances v-model="alliancesSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherShops
                  v-model="shopsSelected"
                  :districtCodes="districtCodes"
                  :districtID="districtID"
                  :allianceBusinessIds="options.alliance_business_ids"
                />
              </v-col>
              <!-- 分组 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  settings && settings.report_hide_search_district_tree == 2
                "
              >
                <SearcherDistrictsWithDescendants
                  v-model="DistrictsSelected"
                  :label="
                    $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherOrderOriginFlgs v-model="options.origin_flgs" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherSelect
                  ref="brand"
                  v-model="options.brand"
                  :items="material_brands"
                  :label="$t('Material.brand')"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherSuppliers
                  ref="supplierSelected"
                  v-model="supplierSelected"
                  :label="$t('Material.default_supplier')"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherOrderStatus v-model="options.status" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherStatus
                  v-model="options.pay_flgs"
                  :items="billPayFlgs"
                  :label="$t('SubAccountAnalyses.payFlags')"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherSingleStatus
                  v-model="options.auto_flg"
                  :label="$t('auto_flg.ObjectName')"
                  :items="$consts.autoFlg"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                v-if="$permission.permissionAllow('Presales', 'index')"
              >
                <SearcherStatus
                  v-model="options.presale_flgs"
                  :items="$consts.subAccountAnalyses.presale_flgs"
                  :label="$t('SubAccountAnalyses.presaleFlgs.title')"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
          v-show="sparklineValues.length"
          class="transparent-background-color"
        >
          <v-expansion-panel-content>
            <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
            <!-- <div id="chartBarBox" style="height: 45vh"></div> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="materialSales"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td colspan="6">
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{ materialSalesTotalNum | formatTwoDot }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ materialSalesTotalPrice | formatMoney }}</span
                >
              </td>
              <td></td>
              <!-- <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{
                  material_distributions_total_num | formatTwoDot
                }}</span>
              </td> -->
              <!-- <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ material_distributions_total_price | formatMoney }}</span
                >
              </td> -->
              <!-- <td></td> -->
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.totalNum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ materialSalesTotalNum | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.totalPrice") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ materialSalesTotalPrice | formatMoney }}
                </div>
              </td>
              <!-- <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.distribution_total_sum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ material_distributions_total_num | formatTwoDot }}
                </div>
              </td> -->
              <!-- <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.distribution_total_price") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money")
                  }}{{ material_distributions_total_price | formatMoney }}
                </div>
              </td> -->
            </tr>
          </template>

          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </template>
          <template v-slot:item.average_price="{ item }"
            >{{ $t("Global.money") }}
            {{ (item.total_price / item.total_sum) | formatMoney }}</template
          >
          <template v-slot:item.total_sum="{ item }">{{
            item.total_sum | formatTwoDot
          }}</template>
          <template v-slot:item.total_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.total_price | formatMoney }}</template
          >
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              outlined
              color="info"
              class="px-2 me-2"
              :href="
                '/#/material-sales/' +
                item.material_id +
                '?auto_flg=' +
                item.auto_flg
              "
            >
              <v-icon x-small class="pe-1">fa-align-left</v-icon>
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
          <!-- 配送均价 -->
          <!-- <template v-slot:item.distripution_average_price="{ item }"
            >{{ $t("Global.money") }}
            {{
              (item.distribution_total_price / item.distribution_total_sum)
                | formatMoney
            }}
          </template> -->
          <!-- 配送量 -->
          <!-- <template v-slot:item.distribution_total_sum="{ item }">{{
            item.distribution_total_sum | formatTwoDot
          }}</template> -->
          <!-- 配送金额 -->
          <!-- <template v-slot:item.distribution_total_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.distribution_total_price | formatMoney }}</template
          > -->
        </v-data-table>
      </div>
    </v-sheet>
    <!-- 导出excel -->
    <v-dialog
      v-model="exportExcelDialog"
      max-width="40%"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="mx-3 d-flex justify-space-between">
          <!-- 无内容的span用于用于调整位置 -->
          <span></span>
          <span>
            {{ $t("Material.remind") }}
          </span>

          <!-- <v-spacer></v-spacer> -->
          <v-tooltip disabled>
            <template v-slot:activator="{ on, attrs }" class="">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  exportExcelDialog = false;
                  styleType = '1';
                "
                >fa-times
              </v-icon>
            </template>
          </v-tooltip>
        </v-card-title>
        <v-divider class="mb-4 mt-2" />
        <!-- excel样式展示 -->
        <v-card-text class="px-4 text-center">
          <v-row justify="center">
            <v-col class="pb-0">
              <v-row justify="center" class="pt-4">
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 pr-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap" align="center">
                    {{ $t("Material.style_one") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/order_material_to_excel_style1.png"
                    :src="require('../../assets/' + $t('$assets.style1'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center" class="pb-4">
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style1')),
                    ])
                  "
                  class="caption"
                  >{{ $t("Material.check") }}</a
                >
              </v-row>

              <v-divider class="my-4" />
              <v-row justify="center" class="pt-4">
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap">
                    {{ $t("Material.style_two") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/order_material_to_excel_style2.png"
                    :src="require('../../assets/' + $t('$assets.style2'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center" class="pb-4">
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style2')),
                    ])
                  "
                  class="caption"
                  >{{ $t("Material.check") }}</a
                >
              </v-row>

              <v-divider class="my-4" />
              <v-row
                justify="center"
                class="pt-4"
                v-if="
                  $permission.permissionAllow(
                    'MaterialSales',
                    'jiangXiTemplateThreeExport'
                  )
                "
              >
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap">
                    {{ $t("Material.style_three") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/order_material_to_excel_style3.png"
                    :src="require('../../assets/' + $t('$assets.style4'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row
                justify="center"
                class="pb-4"
                v-if="
                  $permission.permissionAllow(
                    'MaterialSales',
                    'jiangXiTemplateThreeExport'
                  )
                "
              >
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style4')),
                    ])
                  "
                  class="caption"
                  >{{ $t("Material.check") }}</a
                >
              </v-row>

              <v-row
                justify="center"
                class="pt-4"
                v-if="
                  !$permission.permissionAllow(
                    'MaterialSales',
                    'jiangXiTemplateThreeExport'
                  )
                "
              >
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap">
                    {{ $t("Material.style_three") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/order_material_to_excel_style3.png"
                    :src="require('../../assets/' + $t('$assets.style3'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row
                justify="center"
                class="pb-4"
                v-if="
                  !$permission.permissionAllow(
                    'MaterialSales',
                    'jiangXiTemplateThreeExport'
                  )
                "
              >
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style3')),
                    ])
                  "
                  class="caption"
                  >{{ $t("Material.check") }}</a
                >
              </v-row>

              <v-divider class="my-4" />
              <v-row justify="center" class="pt-4">
                <v-col
                  cols="12"
                  sm="12"
                  md="2"
                  class="py-0 d-flex justify-center align-center font-weight-bold subtitle-2"
                >
                  <div class="text-no-wrap">
                    {{ $t("Material.style_four") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="10" sm="10" md="9" class="py-0 pl-0 ma-0">
                  <v-img
                    lazy-src="../../assets/order_material_to_excel_style2.png"
                    :src="require('../../assets/' + $t('$assets.style5'))"
                    contain
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center" class="pb-4">
                <a
                  @click.stop="
                    $showFullscreenImages([
                      require('../../assets/' + $t('$assets.style5')),
                    ])
                  "
                  class="caption"
                  >{{ $t("Material.check") }}
                </a>
              </v-row>

              <v-divider class="my-4" />
              <!-- 样式选择 -->
              <v-row justify="center" class="py-0">
                <v-radio-group v-model="styleType" row>
                  <v-radio
                    :label="$t('Material.style_one')"
                    value="1"
                  ></v-radio>
                  <v-radio
                    :label="$t('Material.style_two')"
                    value="2"
                  ></v-radio>
                  <v-radio
                    v-if="
                      $permission.permissionAllow(
                        'MaterialSales',
                        'jiangXiTemplateThreeExport'
                      )
                    "
                    :label="$t('Material.style_three')"
                    value="4"
                  ></v-radio>
                  <v-radio
                    v-else
                    :label="$t('Material.style_three')"
                    value="3"
                  ></v-radio>
                  <v-radio
                    :label="$t('Material.style_four')"
                    value="5"
                  ></v-radio>
                </v-radio-group>
              </v-row>

              <v-divider class="mt-4" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end pb-4">
          <v-btn
            @click="
              exportExcelDialog = false;
              styleType = '1';
            "
            >{{ $t("Material.close") }}</v-btn
          >
          <v-btn @click="exportExcel()" color="print" dark>{{
            $t("Material.download")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts.js";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import BarEcharts from "@/components/plugins/BarEcharts";
import SearcherOrderDate from "@/components/plugins/SearcherOrderDate";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherOrderStatus from "@/components/plugins/SearcherOrderStatus";
import SearcherOrderOriginFlgs from "@/components/plugins/SearcherOrderOriginFlgs";
import MaterialSales from "@/api/material_sales";
import Materials from "@/api/materials";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import SearcherSingleStatus from "@/components/plugins/SearcherSingleStatus";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultDatetimeRage = {
  orderDatetimeRadios: "radio-created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  pay_time_from: "",
  pay_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
};

const defaultOptions = {
  orderDatetimeRadios: "radio-created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  pay_time_from: "",
  pay_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  auto_flg: null,
  presale_flgs: [0, 1],
  category_ids: [],
  material_keyword: "",
  alliance_business_ids: [],
  shop_ids: [],
  status: [1, 2, 3, 4, 5, 6],
  origin_flgs: [],
  sortBy: [],
  sortDesc: [],
  pay_flgs: [1, 2, 3],
  brand: "",
  district_ids: [],
  default_supplier_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    BarEcharts,
    SearcherOrderDate,
    SearcherKeyword,
    SearcherMaterialCategoriesWithDescendants,
    SearcherAlliances,
    SearcherShops,
    SearcherOrderStatus,
    SearcherOrderOriginFlgs,
    SearcherStatus,
    SearcherSelect,
    SearcherSuppliers,
    SearcherSingleStatus,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialSales"),
        disabled: true,
        href: "/material-sales",
      },
    ],
    headers: () => [
      {
        text: i18n.t("MaterialSales.TableHeaders.materialCode"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.materialName"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.standard_name"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.averagePrice"),
        align: "end",
        sortable: false,
        value: "average_price",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.unit"),
        align: "center",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.totalNum"),
        align: "end",
        sortable: false,
        value: "total_sum",
      },
      {
        text: i18n.t("MaterialSales.TableHeaders.totalPrice"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
      // 配送均价
      // {
      //   text: i18n.t("MaterialSales.TableHeaders.distripution_average_price"),
      //   align: "end",
      //   sortable: false,
      //   value: "distripution_average_price",
      // },
      // // 配送量
      // {
      //   text: i18n.t("MaterialSales.TableHeaders.distribution_total_sum"),
      //   align: "end",
      //   sortable: false,
      //   value: "distribution_total_sum",
      // },
      // // 配送金额
      // {
      //   text: i18n.t("MaterialSales.TableHeaders.distribution_total_price"),
      //   align: "end",
      //   sortable: false,
      //   value: "distribution_total_price",
      // },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    sparklineLabels() {
      return this.materialSales.map((materialSale) => {
        return materialSale.material_name;
      });
    },
    sparklineValues() {
      return this.materialSales.map((materialSale) => {
        return parseFloat(materialSale.total_price);
      });
    },
    billPayFlgs() {
      if (this.options.orderDatetimeRadios == "radio-pay") {
        return consts.bill.real_pay_flgs;
      } else {
        return consts.bill.pay_flgs;
      }
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "districtID", "settings"]),
  },

  mounted() {
    if (this.$route.query.dateType) {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      if (this.$route.query.dateType == "today") {
        this.options.created_time_from =
          new Date(new Date().getTime()).toISOString().substr(0, 10) +
          " 00:00:00";
        this.options.created_time_to =
          new Date().toISOString().substr(0, 10) + " 23:59:59";
      }
      if (this.$route.query.dateType == "yesterday") {
        this.options.created_time_from =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 00:00:00";
        this.options.created_time_to =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 23:59:59";
      }
      sessionStorage.setItem(
        "material-sales-options",
        JSON.stringify(this.options)
      );
    }
    Materials.fetchFiledSelects({
      field_names: ["brand"],
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.material_brands = response.data.brand;
        }
      }.bind(this)
    );
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("material-sales", [
        "categoriesSelected",
        "alliancesSelected",
        "shopsSelected",
        "DistrictsSelected",
        "supplierSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            this.datetimeRage = Object.assign({}, this.datetimeRage, {
              orderDatetimeRadios: this.options.orderDatetimeRadios,
              created_time_from: this.options.created_time_from,
              created_time_to: this.options.created_time_to,
              actual_time_from: this.options.actual_time_from,
              actual_time_to: this.options.actual_time_to,
              pay_time_from: this.options.pay_time_from,
              pay_time_to: this.options.pay_time_to,
              expect_time_from: this.options.expect_time_from,
              expect_time_to: this.options.expect_time_to,
            });
            this.options.page = 1;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "categoriesSelected":
                this.categoriesSelected = selected.value;
                break;
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    exportExcelDialog: false,
    styleType: "1",
    materialKeyword: "",
    categoriesSelected: [],
    alliancesSelected: [],
    shopsSelected: [],
    supplierSelected: [],
    datetimeRage: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    materialSales: [],
    materialSalesTotalNum: 0,
    materialSalesTotalPrice: 0,
    material_distributions_total_num: 0,
    material_distributions_total_price: 0,
    material_brands: [],
    DistrictsSelected: [],
    districtCodes: [],
  }),

  methods: {
    resetSearch() {
      this.categoriesSelected = [];
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.supplierSelected = [];
      this.DistrictsSelected = [];
      this.datetimeRage = JSON.parse(JSON.stringify(defaultDatetimeRage));
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword, this.$refs.brand].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign(this.options, {
        material_keyword: this.materialKeyword,
      });
      this.getMaterialSalesFromAPI();
    },
    getMaterialSalesFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MaterialSales.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialSales = response.data.material_sales;
            this.materialSalesTotalNum = response.data.material_sales_total_num;
            this.materialSalesTotalPrice =
              response.data.material_sales_total_price;
            this.material_distributions_total_num =
              response.data.material_distributions_total_num;
            this.material_distributions_total_price =
              response.data.material_distributions_total_price;
            this.paging = response.data.paging;
            if (this.materialSales.length == 0) {
              this.options.page = 1;
            }
          } else if (response.data.error.code.isNoResultSet) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MaterialSales.exports(Object.assign(options));
    },
    exportExcelJX() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MaterialSales.exportsJX(options);
    },
  },

  watch: {
    datetimeRage: {
      handler() {
        if (this.datetimeRage.orderDatetimeRadios != "radio-pay") {
          this.options = Object.assign(
            {},
            this.options,
            Object.assign({}, this.datetimeRage, { pay_flgs: [1, 2, 3] })
          );
        } else {
          this.options = Object.assign({}, this.options, this.datetimeRage);
        }
      },
    },
    districtID: {
      handler() {
        this.getMaterialSalesFromAPI();
      },
    },
    categoriesSelected: {
      handler() {
        this.options.category_ids = this.categoriesSelected.map(
          (category) => category.id
        );
        sessionStorage.setItem(
          "material-sales-categoriesSelected",
          JSON.stringify(this.categoriesSelected)
        );
      },
    },
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected.map(
          (alliance) => alliance.id
        );
        sessionStorage.setItem(
          "material-sales-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected.map((shop) => shop.id);
        sessionStorage.setItem(
          "material-sales-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.default_supplier_ids = this.supplierSelected.map((s) => s.id);
        sessionStorage.setItem(
            "material-sales-supplierSelected",
            JSON.stringify(this.supplierSelected)
        );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getMaterialSalesFromAPI();
        sessionStorage.setItem(
          "material-sales-options",
          JSON.stringify(this.options)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2
        ) { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          this.districtCodes = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.code;
            })
            : [];
          sessionStorage.setItem(
            "material-sales-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>